import { render } from "./GTSelect.vue?vue&type=template&id=b768a658&scoped=true"
import script from "./GTSelect.vue?vue&type=script&lang=js"
export * from "./GTSelect.vue?vue&type=script&lang=js"

import "./GTSelect.vue?vue&type=style&index=0&id=b768a658&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b768a658"

export default script